import React, { useEffect } from "react";
import "../../Assets/Styles/pages/landing.scss";
import BlogsList from "../../Components/BlogsList/blogsList";
import BlogsTitle from "../../Components/BlogsTitle/blogsTitle";

const Blogs = ({ limit }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="my-5">
      <BlogsTitle />
      <BlogsList limit={limit} />
    </div>
  );
};

export default Blogs;
